<div class="quantity-stepper">
  <button 
    class="stepper-btn decrement" 
    (click)="decrement()" 
    [disabled]="quantity <= min"
    aria-label="Decrease quantity"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 13H5v-2h14v2z"/>
    </svg>
  </button>
  
  <span class="quantity-display">{{ quantity }}</span>
  
  <button 
    class="stepper-btn increment" 
    (click)="increment()" 
    [disabled]="quantity >= max"
    aria-label="Increase quantity"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
  </button>
</div>
